/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Username_Format_HintInputs */

const vi_user_username_format_hint = /** @type {(inputs: User_Username_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng email hoặc chữ thường không dấu. Ví dụ: ten@congty.vn`)
};

/**

* @param {User_Username_Format_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_username_format_hint = /** @type {((inputs?: User_Username_Format_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Username_Format_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_username_format_hint(inputs)
});